import {gql} from "@apollo/client/core";

const manageParticipantList = gql`
  mutation manageParticipantsGroup($participants: [JSON!], $group_name: String!, $group_id: Float) {
    manageParticipantsGroup(participants: $participants, group_name: $group_name, group_id: $group_id) {
      status
      message
      data
    }
  }
`;

const deleteParticipantList = gql`
  mutation deleteGroup($group_id: Float!) {
    deleteGroup(group_id: $group_id) {
      status
      message
      data
    }
  }
`;

const removeParticipantsFromList = gql`
  mutation removeGroupParticipants($participants_id: [JSON!]!) {
    removeGroupParticipants(participants_id: $participants_id) {
      status
      message
      data
    }
  }
`;

const addParticipantsToList = gql`
  mutation addGroupParticipants($group_id: Float!, $participants: [JSON!]!) {
    addGroupParticipants(group_id: $group_id, participants: $participants) {
      status
      message
      data
    }
  }
`;

const editTags =gql`
  mutation addRemoveTags($participants: [JSON!]!) {
    addRemoveTags(participants: $participants) {
      status
      message
      data
    }
  }
`;

export {
  manageParticipantList,
  deleteParticipantList,
  removeParticipantsFromList,
  addParticipantsToList,
  editTags
}